/* eslint-disable */
import {
  axios,
  config
} from '../api'
import store from '../store'

let shop = {}

// 获取商铺修改信息
shop.getEditDto = (_ID) => {
  return axios('post', config.API_URL + '/api/Shop/GetEditDto', {},{
    ID: _ID
  })
}

// 查询列表
shop.getList = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Shop/GetList', _data)
  }
}

// 添加商铺，ID传递0
shop.add = {
  data: {
    // ID: 0, //新增的时候不传
    Name: '',
    PropNum: '',
    Area: 0,
    // State: '',//新增的时候不传
    // CurrentContractID:'', //新增的时候不传
    FileList:[],
    Notes:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Shop/Add', _data)
  }
}

// 修改商铺，ID传递对应id
shop.edit = {
  data: {
    ID: 0,
    Name: '',
    PropNum: '',
    Area: 0,
    State: '',
    CurrentContractID:'',
    FileList:[],
    Notes:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Shop/Edit', _data)
  }
}

// 删除
shop.del = (_idList) => {
  return axios('post', config.API_URL + '/api/Shop/Del',{}, {
    idList: _idList
  })
}

//通过合同获取不分页的商铺列表
shop.getListByContractID = (_ID) => {
  return axios('post', config.API_URL + '/api/Shop/GetListByContractID', {},{
    contractID: _ID
  })
}

shop.export = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Shop/ExportList',_data,{},1)
  }
}
// 末尾传个参数，就是blob类型，具体查询api/index.js中的axios函数

export default shop



